import React from 'react';

export interface RulesManagerContextProps {
  onLearnMoreClick?: (url: string) => void;
}
export const RulesManagerContext =
  React.createContext<RulesManagerContextProps>({
    onLearnMoreClick: () => ({}),
  });
